export enum TRefEventStates {
  SELECT_REF_TYPE = 'SELECT_REF_TYPE',
  UNDER_REVIEW = 'UNDER_REVIEW',
  CHALLANGE = 'CHALLANGE',
  CHAINS = 'CHAINS',
  PENALTY = 'PENALTY',
}

export enum TRefEventsActions {
  BACK = 'BACK',
  ON_UNDER_REVIEW = 'ON_UNDER_REVIEW',
  ON_OVERTURNED = 'ON_OVERTURNED',
  ON_OVERTURNED_PAT = 'ON_OVERTURNED_PAT',
  ON_CHAINS = 'ON_CHAINS',
  ON_CHALLENGE = 'ON_CHALLENGE',
  PENALTY_SELECTED = 'PENALTY_SELECTED',
  ON_REF_DEFAULT = 'ON_REF_DEFAULT',
  BACK_FROM_REF = 'BACK_FROM_REF',
  BACK_TO_UNDER_REVIEW = 'BACK_TO_UNDER_REVIEW',
  ON_UNDER_REVIEW_SELECTED = 'ON_UNDER_REVIEW_SELECTED',
  BACK_TO_CHAIN = 'BACK_TO_CHAIN',
  ON_CHAINS_SELECTED = 'ON_CHAINS_SELECTED',
  ON_CHALLENGE_SELECTED = 'ON_CHALLENGE_SELECTED',
  BACK_TO_CHALLANGE = 'BACK_TO_CHALLANGE',
  BACK_TO_PENALTY = 'BACK_TO_PENALTY',
  ON_PENALTY_SELECTED = 'ON_PENALTY_SELECTED',
  BACK_TO_REF = 'BACK_TO_REF',
  BACK_TO_KICKOFF_RESULT = 'BACK_TO_KICKOFF_RESULT',
  BACK_TO_IDLE = 'BACK_TO_IDLE',
  BACK_TO_PASS_RESULT = 'BACK_TO_PASS_RESULT',
  BACK_TO_PLAY_DESIGN = 'BACK_TO_PLAY_DESIGN',
  BACK_TO_FUMBLE = 'BACK_TO_FUMBLE',
  BACK_TO_PUNT_TYPE = 'BACK_TO_PUNT_TYPE',
  BACK_TO_PUNT_RESULT = 'BACK_TO_PUNT_RESULT',
  BACK_TO_FG_START = 'BACK_TO_FG_START',
  BACK_TO_FG_RESULT = 'BACK_TO_FG_RESULT',
  BACK_TO_START_KICKOFF = 'BACK_TO_START_KICKOFF',
  BACK_TO_KICKOFF_KICKED = 'BACK_TO_KICKOFF_KICKED',
  BACK_TO_XP = 'BACK_TO_XP',
  BACK_TO_2PT = 'BACK_TO_2PT',
  BACK_TO_XP_SNAP = 'BACK_TO_XP_SNAP',
  BACK_TO_TWO_PT_SNAP = 'BACK_TO_TWO_PT_SNAP',
  BACK_TO_CONFIRMATION = 'BACK_TO_CONFIRMATION',
  COMPLETE_PLAY = 'COMPLETE_PLAY',
  ON_POSSESSION_SELECT = 'ON_POSSESSION_SELECT',
}
